import { getItemsFromCollection } from "directus/src/operations";

export async function fetchCurrencies() {
  try {
    const query = {
      fields: ["id", "name"],
    };
    const response = await getItemsFromCollection("currencies", query);
    return response;
  } catch (error) {
    console.error(error);
    throw error;
  }
}
